import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { getSettings, patchSettings } from "../../lib/api";

export function SettingsTab() {
  const { t, setMaintenanceMode } = useAuth();
  const [maint, setMaint] = useState(false);
  const [msgRu, setMsgRu] = useState("");
  const [msgUk, setMsgUk] = useState("");
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getSettings()
      .then(({ settings }) => {
        setMaint(settings.maintenance_mode === "true");
        setMsgRu(settings.maintenance_message_ru ?? "");
        setMsgUk(settings.maintenance_message_uk ?? "");
      })
      .catch(e => setError(e.message));
  }, []);

  async function save() {
    setSaving(true); setError(null);
    try {
      await patchSettings({
        maintenance_mode: maint ? "true" : "false",
        maintenance_message_ru: msgRu,
        maintenance_message_uk: msgUk,
      });
      setMaintenanceMode(maint);
      setSavedAt(Date.now());
    } catch (e: any) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="p-4 space-y-4">
      <div className="bg-white rounded-2xl p-4 border border-slate-200 space-y-3">
        <div className="text-sm font-semibold text-slate-800">🔧 {t("settings_maintenance_title")}</div>
        <p className="text-xs text-slate-500 leading-relaxed">{t("settings_maintenance_help")}</p>
        <label className="flex items-center gap-3 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={maint}
            onChange={(e) => setMaint(e.target.checked)}
            className="w-5 h-5 accent-indigo-600"
          />
          <span className={`text-sm font-medium ${maint ? "text-rose-700" : "text-slate-700"}`}>
            {maint ? t("settings_maintenance_on") : t("settings_maintenance_off")}
          </span>
        </label>

        <div>
          <label className="text-xs text-slate-500 block mb-1">{t("settings_msg_ru")}</label>
          <textarea
            value={msgRu}
            onChange={(e) => setMsgRu(e.target.value)}
            rows={2}
            className="w-full bg-slate-50 border border-slate-200 rounded-md px-3 py-2 text-sm text-slate-900"
          />
        </div>
        <div>
          <label className="text-xs text-slate-500 block mb-1">{t("settings_msg_uk")}</label>
          <textarea
            value={msgUk}
            onChange={(e) => setMsgUk(e.target.value)}
            rows={2}
            className="w-full bg-slate-50 border border-slate-200 rounded-md px-3 py-2 text-sm text-slate-900"
          />
        </div>

        {error && <div className="text-xs text-rose-600">{error}</div>}
        {savedAt && !error && <div className="text-xs text-emerald-700">✓ {t("settings_saved")}</div>}

        <button
          onClick={save}
          disabled={saving}
          className="w-full bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 text-white text-sm font-semibold rounded-xl px-4 py-2.5 transition"
        >{t("settings_save")}</button>
      </div>
    </section>
  );
}
